import { render } from "./FloatingActionBtnFix.vue?vue&type=template&id=3dc7324c&scoped=true"
import script from "./FloatingActionBtnFix.vue?vue&type=script&lang=js"
export * from "./FloatingActionBtnFix.vue?vue&type=script&lang=js"

import "./FloatingActionBtnFix.vue?vue&type=style&index=0&id=3dc7324c&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc7324c"]])

export default __exports__